import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { cardStyle } from "../cardStyles";

interface EmptyStateProps {
  onAdd: () => void;
}

const EmptyState = ({ onAdd }: EmptyStateProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  return (
    <div
      style={{
        ...cardStyle,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: 40,
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: "#eef2ff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        <GlobalIcon iconName="SimpleUserIcon" size="S" color="#4f46e5" />
      </div>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: "0 0 8px" }}>
        {translate("newDashboard.beneficiaryManager.emptyTitle")}
      </h2>
      <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 20px", maxWidth: 400 }}>
        {translate("newDashboard.beneficiaryManager.emptyDesc")}
      </p>
      <ButtonDS
        label={translate("newDashboard.beneficiaryManager.addButton")}
        buttonType="primary"
        size="40"
        onClick={onAdd}
      />
    </div>
  );
};

export default EmptyState;
